import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { obtenerCotizacionDeGuia, obtenerObservacionesDeGuia } from "./logic";
import { CotizacionView } from "./cotizacionview";

import { ObservacionesView, TiempoAproximado } from "./observacionesview";

import { observeResource } from "kea-resource";

export interface Props {
    value: models.DocumentacionGuia;
}


class ClienteDestino extends React.PureComponent<{ cliente: string, destino: string }> {
    render() {
        return (
            <div>
                <b style={{ color: "blue" }}>{this.props.cliente}</b>
                <br />
                <i>{this.props.destino}</i>
            </div>
        );
    }
}
const ClienteDestinoRx = componentToRx(ClienteDestino);

function obtenerNombreTarifa(guia: models.DocumentacionGuia) {
    const tipo = guia.TarifaSeleccionada;
    if (tipo == null) return null;
    const tarifa =
        tipo == models.TipoTarifa.Destino ? guia.TasasDestino :
            tipo == models.TipoTarifa.Origen ? guia.TasasOrigen :
                tipo == models.TipoTarifa.SinDescuento ? guia.TasasSinDescuento :
                    tipo == models.TipoTarifa.PaquetePP ? guia.TasasPP :
                        assertUnreachable(tipo);

    return tarifa.NombreTarifa;
}

/**
* Componente para ver una guia generada por la documentación
*/
export class DocumentacionGuiaComponent extends React.PureComponent<Props> {
    getField = formfields(() => this.props);
    value = (props: Props) => props.value;
    idDireccion = createSelectorRx(this.value, value => value.IdDireccionClienteDestino);
    direccion = createSelectorRx(this.idDireccion, id => observeResource(resources.Cliente.GetDireccion, id));
    nombreCliente = createSelectorRx(this.direccion, x => x.Cliente.Nombre);
    descripcionDestino = createSelectorRx(this.direccion, x => x.Direccion.Descripcion);

    render() {
        const { value } = this.props;
        const cotiz = obtenerCotizacionDeGuia(value);
        const observaciones = obtenerObservacionesDeGuia(value);
        const clienteDestino = this.nombreCliente(this.props);
        const destino = this.descripcionDestino(this.props);

        return (
            <kea.Panel iconClass={fa("file-text-o")} title={
                <span>
                    {value.Servicios.FletePorCobrar && <label className="label label-danger">FXC</label>}
                    {obtenerNombreTarifa(value)}<i>{" (" + models.TipoTarifa[value.TarifaSeleccionada!] + ")"}</i>
                    {
                        value.ImporteTotalSinDescuento != value.Importes.Total &&
                        <div>
                            <span style={{ color: "blue" }}>
                                Sin descuento: <b>{kea.formatCurrency(value.ImporteTotalSinDescuento)}</b>
                            </span>
                        </div>
                    }
                </span>
            }
            >
                <ClienteDestinoRx cliente={clienteDestino} destino={destino} />
                {/* TODO: no mostrar el tiempo estimado de entrega hasta que la matriz de tiempos tenga valores  */}
                {/* <TiempoAproximado value={value.TiempoFlete} /> */}
                <CotizacionView value={cotiz} />
                <ObservacionesView value={observaciones} />
            </kea.Panel>
        );
    }
}




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/guias/guiaview.tsx